import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class DeliveryTypeRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/delivery/types');
    }

    async getAll() {
        if (Cache.get('delivery-types')) {
            return Cache.get('delivery-types');
        }

        return this.setPerPage(1000).run().then((res) => {
            Cache.set('delivery-types', res);
            return Cache.get('delivery-types');
        });
    }
}
